import { InventoryProduct, ProductItem } from './type';
import { IWarehouseStock } from 'src/types/common/inventory';
export const convertProduct = (
  product: ProductItem,
  available: number,
  inventoryUuid: string,
  warehouseStocks?: IWarehouseStock[],
): InventoryProduct => {
  return { ...product, available, inventoryUuid, warehouseStocks };
};
